import { useParams } from 'react-router-dom';
import useCompetitionProblems from 'hooks/useCompetitionProblems';
import useCompetitionSubmissions from 'hooks/useCompetitionSubmissions';
import Loading from 'components/system/Loading/Loading';
import SubmissionForm from 'components/pages/Competition/Submissions/SubmissionForm';
import isEmpty from 'lodash/isEmpty';
import EmptySubmissions from 'components/pages/Competition/Submissions/EmptySubmissions';

const Submissions = () => {
  const { id: competitionId } = useParams();
  const { competitionProblems, isLoading: isProblemsLoading } = useCompetitionProblems(competitionId);
  const { competitionSubmissions, isLoading: isSubmissionsLoading } = useCompetitionSubmissions(competitionId);

  if (!competitionId || isSubmissionsLoading || isProblemsLoading) {
    return <Loading />;
  }
  if (competitionProblems.length === 0 || isEmpty(competitionSubmissions)) {
    return <EmptySubmissions />;
  }

  return (
    <SubmissionForm
      competitionProblems={competitionProblems}
      competitionSubmissions={competitionSubmissions}
      competitionId={competitionId}
    />
  );
};

export default Submissions;
